module.exports = __webpack_public_path__ + "img/sq_header_aktivni.3f7ea20b.jpg";